import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { LcsChipMultiSelectModule } from 'src/app/common-components/multi-select/multi-select.module';
import { PrivilegeListModule } from 'src/app/common-components/privileges-list/privileges-list.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { CallRecordingExtensionsListModule } from '../call-recording-extensions-list/call-recording-extensions-list.module';
import { ErrorPageModule } from '../error-page/error-page.module';
import { ReportPermissionsListViewModule } from '../report-permissions-list/report-permissions-list.module';
import { UserDetailComponent } from './containers/user-detail.component';
import { UserDetailEffects } from './state/user-detail.effects';
import * as fromUserDetail from './state/user-detail.reducer';
import { UserDetailViewComponent } from './views/user-detail-view.component';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { TabRouterDirectiveModule } from 'src/app/common-components/detail/tab-router-directives.module';

@NgModule({
   declarations: [UserDetailComponent, UserDetailViewComponent],
   imports: [
      CallRecordingExtensionsListModule,
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      MatTabsModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatMenuModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsChipMultiSelectModule,
      LcsAdvancedMultiSelectModule,
      LcsMultiSelectModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      PrivilegeListModule,
      MatSelectModule,
      EntitySelectModule,
      ScrollingModule,
      ReportPermissionsListViewModule,
      StoreModule.forFeature(fromUserDetail.userDetailFeatureKey, fromUserDetail.reducer),
      EffectsModule.forFeature([UserDetailEffects]),
      UpdateDetailsModule,
      ErrorPageModule,
      TabRouterDirectiveModule,
      ResizeOnTabChangeDirectiveModule,
      TooltipModule,
   ],
})
export class UserDetailModule {}
